/* Copyright © 2026 YOUR GROWTH 365 (Jonas Brössel) — Proprietary. See LICENSE in repo root. */
/* =============================================================================
   CORE / DATE-RANGE — Shared Zeitraum-Presets (S180 Auswertung-Rework, Cut 1)
   =============================================================================
   Pure, DOM-freie Übersetzung eines Zeitraum-Presets in ein {from, to}-ISO-Paar
   (YYYY-MM-DD, tz-sicher über dateToISO = Restaurant-Timezone). EINE Quelle für
   den Statistik-Zeitraum-Filter (Cut 1) — Archiv (archive-state.defaultDateRange)
   soll perspektivisch hierauf migrieren (Folge-Aufräumung).

   Presets: today · 7d · 30d · month · custom.
     today → from=to=heute
     7d    → heute−6 … heute        (7 Tage inkl. heute)
     30d   → heute−29 … heute       (30 Tage inkl. heute)
     month → Monatserster … heute
     custom→ vom Aufrufer gesetzte from/to durchreichen
   PURITY: kein Math.random; `now` ist injizierbar (Default new Date()).
============================================================================ */

import { dateToISO } from '../utils/helpers.js';

export const RANGE_PRESETS = Object.freeze(['today', '7d', '30d', 'month', 'custom']);
export const defaultPreset = '7d';

/** Lokales Mitternachts-Date relativ zu `now` (Tagesarithmetik, tz-neutral). */
function _dayOffset(now, days) {
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  d.setDate(d.getDate() + days);
  return d;
}

/**
 * Übersetzt ein Preset in ein {preset, from, to}-Objekt (ISO YYYY-MM-DD).
 * @param {string} preset  one of RANGE_PRESETS
 * @param {Date}   [now]   Referenzzeitpunkt (Default jetzt)
 * @param {{from?:string,to?:string}} [custom]  nur für preset==='custom'
 */
export function rangeForPreset(preset, now = new Date(), custom = null) {
  const todayIso = dateToISO(_dayOffset(now, 0));
  switch (preset) {
    case 'today':
      return { preset: 'today', from: todayIso, to: todayIso };
    case '7d':
      return { preset: '7d', from: dateToISO(_dayOffset(now, -6)), to: todayIso };
    case '30d':
      return { preset: '30d', from: dateToISO(_dayOffset(now, -29)), to: todayIso };
    case 'month': {
      const first = new Date(now.getFullYear(), now.getMonth(), 1);
      return { preset: 'month', from: dateToISO(first), to: todayIso };
    }
    case 'custom':
      return { preset: 'custom', from: (custom && custom.from) || null, to: (custom && custom.to) || null };
    default:
      return rangeForPreset(defaultPreset, now);
  }
}
